export const submissionTaskDtoFields = [{
        name: "order",
        title: "Subtask",
        render: (record) => record.order
    }, {
        name: "executionOk",
        title: "Execution",
        render: (record) => `<i class="material-icons">${record.executionOk === 1 ? "check" : "close"}</i>`
    }, {
        name: "points",
        title: "Points",
        render: (record) => record.points + " / " + record.maxPoints
    }, {
        name: "runtimeMs",
        title: "Run Time (ms)",
        render: (record) => record.runtimeMs
    }, {
        name: "resultsOk",
        title: "Outcome",
        render: (record) => record.resultsOk === 1 ? 'OK' : 'Wrong output'
    }];
